import { isEmpty, isInsufficientText } from './generic';

const isDisabled = (text: string, status: string | undefined): boolean => {
  return isEmpty(text) || isInsufficientText(text) || status === 'pending';
};

const tooltipContent = (text: string, status: string | undefined): string => {
  if (isEmpty(text)) {
    return 'No text to expand';
  }
  if (isInsufficientText(text)) {
    return 'Not enough text to expand';
  }
  if (status === 'pending') {
    return 'Expanding text...';
  }
  return 'Expand text';
};

export const expandUtils = {
  getStatus(options: { text: string; status?: string }): {
    isDisabled: boolean;
    tooltipContent: string;
    isInsufficientText: boolean;
  } {
    return {
      isDisabled: isDisabled(options.text, options.status),
      tooltipContent: tooltipContent(options.text, options.status),
      isInsufficientText: isInsufficientText(options.text),
    };
  },
};
